/* eslint react/button-has-type: "off" */
import * as React from 'react';
import classNames from 'classnames';
import {NOOP} from '../utilities';
import style from './button.scss';

type AnchorElementProps = JSX.IntrinsicElements['a'];
type ButtonElementProps = JSX.IntrinsicElements['button'];

export interface ButtonProps {
  type?: string;
  label?: React.ReactNode;
  light?: boolean;
  cancel?: boolean;
  secondary?: boolean;
  block?: boolean;
  tall?: boolean;
  url?: string;
}

type ComposedProps = ButtonProps & AnchorElementProps & ButtonElementProps;

const DEFAULT_BUTTON_TYPE = 'button';

export function Button({
  url = '',
  tall = false,
  type = DEFAULT_BUTTON_TYPE,
  label = '',
  block = false,
  light = false,
  cancel = false,
  onClick = NOOP,
  className,
  secondary = false,
  ...restProps
}: ComposedProps) {
  const buttonClasses = classNames(style.button, className, {
    [style.secondary]: secondary,
    [style.light]: light,
    [style.cancel]: cancel,
    [style.block]: block,
    [style.tall]: tall,
  });

  return url ? (
    <a className={buttonClasses} href={url} onClick={onClick} {...restProps}>
      {label}
    </a>
  ) : (
    <button className={buttonClasses} type={type} onClick={onClick} {...restProps}>
      {label}
    </button>
  );
}
